import { Pipe, PipeTransform } from '@angular/core';

import { tipoClassificacaoCadastros } from '../cadastro';
import { TipoClassificacao } from '../tipo-classificacao';
import { TipoClassificacaoGrupoCadastro } from '../tipo-classificacao-grupo-cadastro';
import { TipoClassificacaoCadastroFilterPipe } from './tipo-classificacao-cadastro-filter.pipe';

@Pipe({
    name: 'tipoClassificacaoGrupoCadastroFilter',
    pure: false
})
export class TipoClassificacaoGrupoCadastroFilterPipe implements PipeTransform {

    constructor(private tipoClassificacaoCadastroFilterPipe: TipoClassificacaoCadastroFilterPipe) { }

    /** Filtra e cria os grupos de tipos de classificações pelos cadastros */
    transform(entities: TipoClassificacao[]): TipoClassificacaoGrupoCadastro[] {
        if (!entities) {
            return [];
        }

        // Criando os grupos de todos os cadastros
        const grupos: TipoClassificacaoGrupoCadastro[] = [];
        tipoClassificacaoCadastros.forEach(cadastro => {
            const grupo = new TipoClassificacaoGrupoCadastro(cadastro);
            grupo.tiposClassificacoes = this.tipoClassificacaoCadastroFilterPipe.transform(entities, cadastro.id);

            if (grupo.tiposClassificacoes.length > 0) {
                grupos.push(grupo);
            }
        });

        return grupos;
    }
}
